import React from "react";
import { node, oneOf, string } from "prop-types";
import {
	utilityClassName,
	utilityProps,
	utilityPropTypes,
} from "@insightfulscience/atomic-react/props/utility";
import { classes } from "../utils/classes";

const Badge = ({
	type = 1,
	Tag = "span",
	status = "active",
	utility = { ...utilityProps },
	className = "",
	children,
}) => {
	return (
		<Tag
			className={classes(
				"badge",
				`badge-v${type}`,
				`badge-v${type}--${status}`,
				...utilityClassName(utility),
				className,
			)}
		>
			{children}
		</Tag>
	);
};

Badge.propTypes = {
	Tag: string,
	type: oneOf([1, 2]),
	utility: utilityPropTypes,
	status: oneOf(["active", "cancelled", "expired", "past-due", "pastdue", "early-access"]),
	className: string,
	children: node.isRequired,
};

export default Badge;
